import React from "react";
import VehicleGenericSkeleton from "./VehicleGenericSkeleton";

function VehicleDetailSkeleton() {
  return (
    <>
      <VehicleGenericSkeleton />
    </>
  );
}

export default VehicleDetailSkeleton;
